/**
 * Vendor Endpoints
 * SUPERADMIN: Vendor management APIs
 *
 * NOTE: Do NOT include 'v1/' prefix - the base URL already contains it.
 * Correct: 'vendor/list-vendors'
 * Wrong:   'v1/vendor/list-vendors'
 */
export const SUPERADMIN_VENDOR_ENDPOINTS = {
  // Vendor Management
  listVendors: 'vendor/list-vendors',
  createVendor: 'vendor/create-vendor',
  updateVendor: 'vendor/update-vendor',
  updateVendorStatus: 'vendor/update-vendor-status',
  testConnection: 'vendor/test-connection',

  // Vendor Product Management
  listProducts: 'vendor/list-products',
  uploadProducts: 'vendor/upload-products',
};

/**
 * Master Catalogue Products Endpoints
 * SUPERADMIN: Master catalogue management APIs
 *
 * NOTE: Do NOT include 'v1/' prefix - the base URL already contains it.
 */
export const SUPERADMIN_MASTER_CATALOGUE_ENDPOINTS = {
  uploadProducts: 'master-catalogue-products/upload-products',
  listProducts: 'master-catalogue-products/list-products',
  getProduct: 'master-catalogue-products/get-product',
  updateProduct: 'master-catalogue-products/update-product',
  updateDenominationStatus: 'master-catalogue-products/update-denomination-status',
  updateProductStatus: 'master-catalogue-products/update-product-status',
};

/**
 * Catalogue (Categories) Endpoints
 * SUPERADMIN: Catalogue/Category management APIs
 *
 * NOTE: Do NOT include 'v1/' prefix - the base URL already contains it.
 */
export const SUPERADMIN_CATALOGUE_ENDPOINTS = {
  listCatalogues: 'catalogue/list-catalogues',
  createCatalogue: 'catalogue/create-catalogue',
  updateCatalogue: 'catalogue/update-catalogue',
};

/**
 * Product Vendor Mapping Endpoints
 * SUPERADMIN: Product-vendor mapping and fulfillment logic APIs
 *
 * NOTE: Do NOT include 'v1/' prefix - the base URL already contains it.
 */
export const SUPERADMIN_PRODUCT_VENDOR_MAPPING_ENDPOINTS = {
  mapVendor: 'product-vendor-mapping/map-vendor',
  getMappings: 'product-vendor-mapping/get-mappings',
  updateFulfilmentLogic: 'product-vendor-mapping/update-fulfilment-logic',
  updateMapping: 'product-vendor-mapping/update-mapping',
};

/**
 * Program Product Whitelist Endpoints
 * SUPERADMIN: Program-wise product whitelisting APIs
 *
 * NOTE: Do NOT include 'v1/' prefix - the base URL already contains it.
 */
export const SUPERADMIN_PROGRAM_PRODUCT_WHITELIST_ENDPOINTS = {
  listAvailable: 'program-product-whitelist/list-available',
  listWhitelisted: 'program-product-whitelist/list-whitelisted',
  addToProgram: 'program-product-whitelist/add-to-program',
  updateWhitelisted: 'program-product-whitelist/update-whitelisted',
  updateProductStatus: 'program-product-whitelist/update-product-status',
};
